export const AT_ACTION_LIMIT = 'AT_ACTION_LIMIT';
export const BELOW_ACTION_LIMIT = 'BELOW_ACTION_LIMIT';
export const OVER_ACTION_LIMIT = 'OVER_ACTION_LIMIT';